import React from 'react';
import { legal } from '../data/story';
export function LegalFooter() {
  return <footer className="mt-10 border-t border-neutral-200 bg-neutral-100 px-5 py-6 text-center sm:px-8" data-id="element-13" data-mp="1raf5d9xy9dnn">
      <div className="mx-auto max-w-[760px] space-y-2" data-id="element-14" data-mp="259oj82yonvog">
        {legal.paragraphs.map(paragraph => <p key={paragraph.slice(0, 32)} className="font-ui text-[9px] leading-relaxed text-neutral-400" data-id="element-15" data-mp="217tlf8fyo0ff">
            {paragraph}
          </p>)}
      </div>

      <nav aria-label="Legal" className="mt-4 flex flex-wrap items-center justify-center gap-x-3 gap-y-1" data-id="element-16" data-mp="2a9ja46igkl9i">
        {legal.links.map(link => <a key={link} href="#legal" className="font-ui text-[10.5px] text-neutral-500 hover:text-purple-brand hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-brand" data-id="element-17" data-mp="2ozqpgdd65o5z">
            {link}
          </a>)}
      </nav>

      <p className="mt-3 font-ui text-[9px] text-neutral-300" data-id="element-18" data-mp="21me7etacvwo8">{legal.copyright}</p>
    </footer>;
}